export enum IBaseError {
  "DANGER" = "danger",
  "WARNING" = "warning",
  "INFO" = "info",
  "DESCRIPTION" = "description",
}
